module.exports = "<div class=\"_home\">\n\n  <main>\n\n    <v-container class=\"content-container\" fluid>\n\n      <v-layout column justify-center>\n        <p class=\"main-icon mt-3 mb-5 text-md-center\"></p>\n\n        <h3 class=\"text-lg-center text-md-center text-xs-center\">WELCOME IN THE PUBLIC AREA</h3>\n      </v-layout>\n\n    </v-container>\n\n  </main>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/views/home/home.vue
// module id = 415
// module chunks = 0